import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "jr-text-xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "少ない", -1)
const _hoisted_3 = { class: "jr-inline-block jr-align-middle jr-px-2.5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "多い", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["jr-flex jr-w-content jr-items-center jr-rounded-lg jr-z-10 jr-bg-white jr-px-3.9 jr-py-2.5", { 'jr-shadow-lg': !_ctx.captureClip }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color) => {
          return (_openBlock(), _createElementBlock("li", {
            key: color,
            class: "jr-inline-block jr-w-2.5 jr-h-2.5",
            style: _normalizeStyle({ 'background-color': color })
          }, null, 4))
        }), 128))
      ]),
      _hoisted_4
    ])
  ], 2))
}